import {
  EXTEND_CHECK_TEXT,
  IMPORTANT_INFO_LI_TEXT1,
  IMPORTANT_INFO_LI_TEXT2,
  IMPORTANT_INFO_LI_TEXT3,
  IMPORTANT_INFO_PARAGRAPH,
} from "./ExtendTerm.const";
import { ExtendTermHeader } from "./ExtendTermHeader";
import { ExtendTermBy } from "./ExtendTermBy";
import {
  ExistingLoanDetails,
  RepaymentOption,
} from "domain/indicativeRepaymentOptions";
import { CheckBox } from "components/common/CheckBox";
import { ImportantInformation } from "components/common/ImportantInformation";
import { IndicativeCalculationBanner } from "components/common/IndicativeCalculationBanner";
import { Button } from "reactstrap";
import { IMPORTANT_INFO_NOTE } from "components/RequestRepaymentHoliday/RequestRepaymentHoliday.const";
import { CreateEnhancer } from "util/enhancer";

type ExtendTermProps = {
  repaymentOption: RepaymentOption;
  existingLoanDetails: ExistingLoanDetails;
  checked: boolean;
  onProgress: () => void;
  onChecked: (checked: boolean) => void;
};

const ExtendTerm = ({
  repaymentOption,
  existingLoanDetails,
  checked,
  onChecked,
  onProgress: handleClick,
}: ExtendTermProps) => {
  const importantList = [
    IMPORTANT_INFO_LI_TEXT1,
    IMPORTANT_INFO_LI_TEXT2,
    IMPORTANT_INFO_LI_TEXT3,
  ];
  return (
    <>
      <div>
        <ExtendTermHeader />
        <ExtendTermBy
          existingLoanDetails={existingLoanDetails}
          repaymentOption={repaymentOption}
        />
        <ImportantInformation
          title={IMPORTANT_INFO_PARAGRAPH}
          list={importantList}
        />
        <p>{IMPORTANT_INFO_NOTE}</p>
        <IndicativeCalculationBanner />
        <CheckBox
          confirmType
          id="checkbox"
          checked={checked}
          label={EXTEND_CHECK_TEXT}
          onChange={onChecked}
        />
      </div>
      <div className="button-end">
        <Button
          color="primary"
          size="lg"
          disabled={!checked}
          onClick={handleClick}
        >
          Next
        </Button>
      </div>
    </>
  );
};
const ExtendTermEnhanced = CreateEnhancer<ExtendTermProps, "repaymentOption">(
  (p) => !p.repaymentOption
)(ExtendTerm);

export { ExtendTermEnhanced as ExtendTerm };
